var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn--primary px-4 ml-3",attrs:{"type":"button"},on:{"click":_vm.openCreateWalletModal}},[_vm._v(" Create Wallet ")]),_c('CreateWalletModal',{attrs:{"id":'createWallet',"closeModal":_vm.closeModal,"walletRef":_vm.walletRef}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }